import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class ContainerValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        let isValid = true;

        this.attribute.attributes.forEach(childAttribute => {
            let validator = ValidationStrategyFactory.create(childAttribute, this.injectedOptions);
            let isValidChild = validator.validate();
            isValid = isValidChild && isValid;
        });

        return isValid
    }
}